export default "__VITE_ASSET__Bw288YzG__"